var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdowntoggle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.681 6.99967C13.681 10.6816 10.6962 13.6663 7.01432 13.6663C3.33242 13.6663 0.347656 10.6816 0.347656 6.99967C0.347656 3.31778 3.33242 0.333008 7.01432 0.333008C10.6962 0.333008 13.681 3.31778 13.681 6.99967ZM4.34794 6.33468C4.34794 6.15757 4.41778 5.9876 4.54232 5.86168C4.60368 5.7998 4.67669 5.75068 4.75713 5.71716C4.83756 5.68364 4.92385 5.66638 5.01099 5.66638C5.09813 5.66638 5.18441 5.68364 5.26485 5.71716C5.34529 5.75068 5.4183 5.7998 5.47966 5.86168L7.01766 7.41301L8.54966 5.86834C8.61088 5.80622 8.68384 5.75689 8.7643 5.72322C8.84475 5.68954 8.9311 5.6722 9.01832 5.6722C9.10554 5.6722 9.19189 5.68954 9.27235 5.72322C9.35281 5.75689 9.42577 5.80622 9.48699 5.86834C9.61137 5.99436 9.68111 6.16429 9.68111 6.34134C9.68111 6.5184 9.61137 6.68833 9.48699 6.81434L7.53366 8.78434C7.39166 8.92768 7.20699 8.99901 7.02099 8.99901C6.83499 8.99901 6.64699 8.92768 6.50166 8.78434L4.54232 6.80768C4.41778 6.68175 4.34794 6.51178 4.34794 6.33468Z",
    fill: "#FFAB00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdowntoggle);
export default __webpack_public_path__ + "static/media/dropdowntoggle.2518b659.svg";
export { ForwardRef as ReactComponent };